{
    "name": "Hari",
    "role": "Frontend Engineer",
    "mail": "harisridhar77@gmail.com",
    "dob": "Nov 12 1998",
    "location": "Dublin, Ireland",
    "date": "Created Aug 2023",
    "tagline": "Weaving the tapestry of imagination with the thread of code 💫",
    "gemini-ai-logo": "https://www.gstatic.com/lamda/images/gemini_sparkle_red_4ed1cbfcbc6c9e84c31b987da73fc4168aec8445.svg",
    "resume": "https://wehtkz1sdfqsaxvd.public.blob.vercel-storage.com/Hari_S_Frontend_Engineer_Resume_2.pdf"
}
